// extracted by mini-css-extract-plugin
export default {"wrapper":"index_wrapper__njAEN","message":"index_message__fErEd"};